<template>
  <div class="trans-text-format">
    <div v-html="getpopoverContent"></div>
  </div>
</template>

<script>
import filters from "@/mixins/filters";

export default {
  name: 'trans-text-format',
  mixins: [filters],
  props: {
    tableData: Object,
    scope: Object,
    bind: String
  },
  computed: {
    getpopoverContent () {
      return this.scope.row[this.bind]
    }
  },
}
</script>

<style lang="scss" scoped>
.content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.5em;
}
</style>